import { useEffect, useState } from "react";
import { backend, billurl, producturl } from "../../../../path";
import useRazorpay from "react-razorpay";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import { Link, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

function MyOrdersUser() {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [Razorpay] = useRazorpay();
  const [formData, setFormData] = useState({});
  const [newAdd] = useState({});
  const [count, setCountry] = useState([]);
  // const [open, setOpen] = useState(false);
  // const [delivery, setDelivery] = useState(false);
  // const [newDelivery, setNewDelivery] = useState(false);
  const [copy, setCopy] = useState(false);
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;

  const [authenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const fetchData = () => {
    setLoading(true);

    fetch(backend + `getmyorders`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchCountryData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcountry", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCountry(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAddress = () => {
    setLoading(true);

    fetch(backend + "getaddress", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Modify the object to include is_primary: 0
        // const updatedData = {
        //   ...data,
        //   is_primary: 0
        // };
        // Set the form data with the updated object
        setFormData(data[0]);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const calculateTotalMRP = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.total;
    });
    return total;
  };

  useEffect(() => {
    fetchData();
    fetchCountryData();
    fetchAddress();
  }, []);

  // const handleQuantityChange = async (id, qty) => {
  //   console.log("Handling quantity change for ID:", id);
  //   console.log("New quantity:", qty);

  // };

  const handleCancelClick = (orderId) => {
    const userConfirmed = window.confirm(
      "Are you sure you want to cancel this order ? 🙁"
    );
    if (userConfirmed) {
      handleCancelOrder(orderId);
    }
  };

  const handleCancelOrder = async (id) => {
    const formData = {
      order_id: id,
    };
    try {
      const response = await fetch(backend + `cancelorder`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        fetchData();
        toast.success("Order Cancelled 🥹", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //payment

  const handlePayment = async (id, total, details) => {
    if (!RAZORPAY_KEY) {
      toast.error("Payment gateway unavailable. Please contact support.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const options = {
      key: RAZORPAY_KEY,
      amount: total * 100,
      currency: "INR",
      name: "Kerala Specials",
      description: "Order Payment",
      image: "https://example.com/your_logo",
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        handleSuccessOrder(id, response.razorpay_payment_id);
      },
      prefill: {
        name: `${details.first_name} ${details.last_name}`,
        email: `${details.email}`,
        contact: `${details.contact}`,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });

    rzp1.on("payment.success", function (response) { });
    rzp1.open();
  };

  const handleSubmit = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      { key: "house_name", displayName: "House Name" },
      { key: "street_name", displayName: "Street Name" },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = formData[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Stop further execution
    }

    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          handleOrder();
          // Additional success handling code here
          toast.success("Primary Address Updated", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  const handleSubmitNewAddress = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      { key: "house_name", displayName: "House Name" },
      { key: "street_name", displayName: "Street Name" },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = newAdd[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Stop further execution
    }

    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(newAdd),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then((data) => {
          handleOrderAddress(data?.delivery_address_id);
          // Additional success handling code here
          toast.success("Address Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleOrder = () => {
    let payload = {};
    payload.delivery_id = formData.delivery_address_id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then((data) => {
          handlePayment(data.order_no, data.grandTotalPrice, data.user_details);
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleOrderAddress = (id) => {
    let payload = {};
    payload.delivery_id = id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then((data) => {
          handlePayment(data.order_no, data.grandTotalPrice, data.user_details);
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleSuccessOrder = (order_id, pay_id) => {
    let payload = {};
    payload.razorpay_payment_id = pay_id;
    payload.order_no = order_id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "successfullpayment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          toast.success("Order Placed Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleCopyTracking = (trackingId) => {
    navigator.clipboard
      .writeText(trackingId)
      .then(() => {
        console.log("Tracking ID copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy tracking ID: ", err);
      });
    setCopy(true);
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Processing";
      case 2:
        return "Dispatched";
      case 3:
        return "Delivered";
      case 4:
        return "Cancelled";
      default:
        return "Pending";
    }
  };

  const getStatusVariant = (status) => {
    switch (status) {
      case 1:
        return "warning";
      case 2:
        return "info";
      case 3:
        return "success";
      case 4:
        return "danger";
      default:
        return "neutral";
    }
  };




  const ordersCount = data.length;
  const deliveredCount = data.filter((item) => item?.status === 3).length;
  const totalAmount = calculateTotalMRP();

  return (
    <main className="main" id="main-section">
      <PageWrapper>
        <HeroSection>
          <BreadcrumbTrail>
            <Link to="/">Home</Link>
            <span>/</span>
            <span>My Orders</span>
          </BreadcrumbTrail>
          <HeroContent>
            <HeroBadge>Order Overview</HeroBadge>
            <HeroTitle>Your KeralaSpecial orders</HeroTitle>
            <HeroSubtitle>
              Track your purchases, follow deliveries, and manage your experience in one elegant view.
            </HeroSubtitle>
            <HeroStats>
              <StatCard>
                <StatValue>{ordersCount}</StatValue>
                <StatLabel>Total orders</StatLabel>
              </StatCard>
              <StatCard>
                <StatValue>{deliveredCount}</StatValue>
                <StatLabel>Delivered</StatLabel>
              </StatCard>
              {/* <StatCard>
                <StatValue>₹ {totalAmount}</StatValue>
                <StatLabel>Total spend</StatLabel>
              </StatCard> */}
            </HeroStats>
          </HeroContent>
        </HeroSection>

        <OrdersSection>
          <SectionHeader>
            <SectionTitle>Order history</SectionTitle>
            <SectionSubtitle>
              Explore order status, delivery details, and invoices. Cancel or track your packages with ease.
            </SectionSubtitle>
          </SectionHeader>

          {loading ? (
            <LoaderWrapper>
              <LoaderMain />
            </LoaderWrapper>
          ) : ordersCount > 0 ? (
            <OrderGrid>
              {data.map((item) => {
                const statusLabel = getStatusLabel(item?.status);
                const statusVariant = getStatusVariant(item?.status);
                const manufacturer = item?.manufacturer_name ?? "KeralaSpecial";
                const address = [
                  item?.house_name,
                  item?.street_name,
                  item?.city,
                  item?.pincode,
                ]
                  .filter(Boolean)
                  .join(", ");
                const hasTracking = Boolean(item?.tracking_id);
                const hasBill = Boolean(item?.bill_file);

                return (
                  <OrderCard key={`${item?.order_id}-${item?.product_slug}`}>
                    <CardHeader>
                      <ProductPreview onClick={() => handleProductRoute(item.product_slug)}>
                        <ProductImage src={producturl + item?.thumbnail} alt={item?.product_name} />
                      </ProductPreview>
                      <HeaderContent>
                        <ProductCategory onClick={() => handleProductRoute(item.product_slug)}>
                          {item?.category_name}
                        </ProductCategory>
                        <ProductName href={`/product/${item.product_slug}`}>
                          {item?.product_name}
                        </ProductName>
                        <ProductMeta>
                          Sold by <strong onClick={() => handleProductRoute(item.product_slug)}>{manufacturer}</strong>
                        </ProductMeta>
                      </HeaderContent>
                      <StatusRow>
                        <StatusBadge variant={statusVariant}>{statusLabel}</StatusBadge>
                        {hasTracking && <TrackingId>Tracking ID: {item.tracking_id}</TrackingId>}
                      </StatusRow>
                    </CardHeader>

                    <CardBody>
                      <AddressBlock>
                        <AddressLabel>Delivery address</AddressLabel>
                        <AddressText>{address}</AddressText>
                      </AddressBlock>

                      <OrderSummary>
                        <AmountBlock>
                          <SummaryLabel>Total amount</SummaryLabel>
                          <SummaryValue>₹ {item?.original_amount}</SummaryValue>
                        </AmountBlock>
                        <AmountBlock>
                          <SummaryLabel>Quantity</SummaryLabel>
                          <SummaryValue>{item?.quantity}</SummaryValue>
                        </AmountBlock>
                      </OrderSummary>

                      <ActionArea>
                        <ActionButtons>
                          {item?.return === 0 && item?.status !== 4 && (
                            <CancelButton
                              type="button"
                              isHovered={isHovered}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              onClick={() => handleCancelClick(item?.order_id)}
                            >
                              Cancel order
                            </CancelButton>
                          )}

                          {hasTracking && (
                            <TrackingActions>
                              <CopyButton type="button" onClick={() => handleCopyTracking(item.tracking_id)}>
                                {copy ? "Copied" : "Copy tracking ID"}
                                <CopyIcon
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M9.17 6H7.5A1.5 1.5 0 0 0 6 7.5v19A1.5 1.5 0 0 0 7.5 28H12a1 1 0 1 1 0 2H7.5A3.5 3.5 0 0 1 4 26.5v-19A3.5 3.5 0 0 1 7.5 4h1.67A3 3 0 0 1 12 2h6c1.306 0 2.418.835 2.83 2h1.67A3.5 3.5 0 0 1 26 7.5a1 1 0 1 1-2 0A1.5 1.5 0 0 0 22.5 6h-1.67A3 3 0 0 1 18 8h-6a3 3 0 0 1-2.83-2M11 5a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1m3 8.5a3.5 3.5 0 0 1 3.5-3.5h8a3.5 3.5 0 0 1 3.5 3.5v13a3.5 3.5 0 0 1-3.5 3.5h-8a3.5 3.5 0 0 1-3.5-3.5z" fill="currentColor" />
                                </CopyIcon>
                              </CopyButton>
                              <TrackButton
                                as="a"
                                href={item?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Track package
                              </TrackButton>
                            </TrackingActions>
                          )}

                          {hasBill && (
                            <DownloadButton
                              as="a"
                              href={billurl + item?.bill_file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Download bill
                            </DownloadButton>
                          )}
                        </ActionButtons>
                      </ActionArea>
                    </CardBody>
                  </OrderCard>
                );
              })}
            </OrderGrid>
          ) : (
            <EmptyState>
              <EmptyTitle>No orders yet</EmptyTitle>
              <EmptySubtitle>
                You haven't done any orders yet! Discover handcrafted delights and place your first order today.
              </EmptySubtitle>
            </EmptyState>
          )}
        </OrdersSection>

        <ToastContainer />
        <ScrollToTop />
      </PageWrapper>
    </main>
  );
}

export default MyOrdersUser;

const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 0 24px 96px;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const HeroSection = styled.section`
  margin-top: 56px;
  background: linear-gradient(135deg, #fff3e2 0%, #ffffff 65%);
  border-radius: 32px;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 40px 80px rgba(15, 23, 42, 0.08);

  @media screen and (max-width: 768px) {
    padding: 40px 28px;
  }
`;

const BreadcrumbTrail = styled.nav`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #6b7280;

  a {
    color: inherit;
    font-weight: 500;
  }

  span:last-child {
    color: #111827;
    font-weight: 600;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(98, 188, 1, 0.15);
  color: #255121;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  font-weight: 600;
`;

const HeroTitle = styled.h1`
  margin: 0;
  font-size: 44px;
  line-height: 1.1;
  color: #0f172a;

  @media screen and (max-width: 768px) {
    font-size: 34px;
  }
`;

const HeroSubtitle = styled.p`
  margin: 0;
  color: #374151;
  line-height: 1.7;
  font-size: 16px;
`;

const HeroStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 20px;
`;

const StatCard = styled.div`
  min-width: 160px;
  padding: 18px 20px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StatValue = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
`;

const StatLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const OrdersSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 1.2px;
`;

const SectionSubtitle = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 15px;
`;

const OrderGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const OrderCard = styled.article`
  background: #ffffff;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 640px) {
    padding: 24px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const ProductPreview = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 18px;
  overflow: hidden;
  width: 108px;
  height: 108px;
  cursor: pointer;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-4px);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
`;

const ProductCategory = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #62bc01;
  font-weight: 600;
  cursor: pointer;
`;

const ProductName = styled.a`
  font-size: 22px;
  font-weight: 600;
  color: #0f172a;
  text-decoration: none;
  display: inline-block;

  &:hover {
    color: #62bc01;
  }
`;

const ProductMeta = styled.span`
  font-size: 14px;
  color: #475569;

  strong {
    font-weight: 600;
    color: #0f172a;
    cursor: pointer;
  }
`;

const StatusRow = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    width: 100%;
    align-items: flex-start;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: ${({ variant }) =>
    variant === "success"
      ? "#0f5132"
      : variant === "danger"
        ? "#b91c1c"
        : variant === "warning"
          ? "#92400e"
          : variant === "info"
            ? "#1d4ed8"
            : "#334155"};
  background: ${({ variant }) =>
    variant === "success"
      ? "rgba(16, 185, 129, 0.16)"
      : variant === "danger"
        ? "rgba(248, 113, 113, 0.16)"
        : variant === "warning"
          ? "rgba(251, 191, 36, 0.16)"
          : variant === "info"
            ? "rgba(96, 165, 250, 0.16)"
            : "rgba(148, 163, 184, 0.2)"};
`;

const TrackingId = styled.span`
  font-size: 13px;
  color: #4b5563;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const AddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const AddressLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const AddressText = styled.p`
  margin: 0;
  color: #1f2937;
  font-size: 15px;
  line-height: 1.6;
`;

const OrderSummary = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const AmountBlock = styled.div`
  min-width: 140px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(98, 188, 1, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SummaryLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #467413;
`;

const SummaryValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #0e3910;
`;

const ActionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const CancelButton = styled.button`
  padding: 12px 20px;
  border-radius: 999px;
  border: 1px solid ${({ isHovered }) => (isHovered ? "#fff" : "#b91c1c")};
  background: ${({ isHovered }) => (isHovered ? "#b91c1c" : "#ffffff")};
  color: ${({ isHovered }) => (isHovered ? "#fff" : "#b91c1c")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
`;

const TrackingActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 999px;
  border: none;
  background: #111827;
  color: #f9fafb;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(30, 41, 59, 0.2);
  }
`;

const CopyIcon = styled.svg`
  width: 18px;
  height: 18px;
`;

const TrackButton = styled.button`
  padding: 12px 22px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #62bc01 0%, #3a7d16 100%);
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(98, 188, 1, 0.35);
  }
`;

const DownloadButton = styled.button`
  padding: 12px 22px;
  border-radius: 999px;
  border: none;
  background: rgba(17, 24, 39, 0.08);
  color: #111827;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(15, 23, 42, 0.15);
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
`;

const EmptyState = styled.div`
  padding: 80px 20px;
  border-radius: 32px;
  background: rgba(15, 23, 42, 0.04);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const EmptyTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #0f172a;
`;

const EmptySubtitle = styled.p`
  margin: 0;
  font-size: 15px;
  color: #475569;
`;
